import useCoolingSite from './hooks/useCoolingSite'
import CoolingSiteView from './components/CoolingSiteView'

const CoolingSiteMain = () => {
  const vm = useCoolingSite()
  return <CoolingSiteView {...vm} />
}

export default CoolingSiteMain
